type ContractorTradeTask = {
  trade?: string | null;
  template?: {
    trade?: string | null;
  } | null;
};

const normalizeTrade = (trade?: string | null) => trade?.trim() || undefined;

/**
 * Returns the trade that should drive contractor matching for a task.
 * Template trades win, and untagged tasks fall back to the general-contractor lane.
 */
export const getTaskTradeForContractorAssignment = (task: ContractorTradeTask): string =>
  normalizeTrade(task.template?.trade)
  || normalizeTrade(task.trade)
  || 'general';

/**
 * Returns whether a contractor can be assigned to a trade in the Renovator UI.
 * General contractors remain selectable across trade-specific lanes.
 */
export const contractorCanPerformTrade = (
  contractorTrades: string[] | null | undefined,
  requiredTrade: string,
) =>
  !!contractorTrades
  && (
    contractorTrades.includes(requiredTrade)
    || contractorTrades.includes('general')
  );
